// OutletWrapper.jsx
import { useLocation, useOutlet } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import PropTypes from 'prop-types';

/**
 *
 * @param {object} props The props.
 * @param {number} props.slide The slide.
 * @param {number} props.slideUp The slide up.
 * @param {boolean} props.keyType The initial.
 * @returns {JSX.Element} The rendered OutletWrapper component.
 */
const OutletWrapper = ({ slide = 0, slideUp = 0, keyType = false }) => {
  const location = useLocation();
  const outlet = useOutlet();

  const getKey = () => {
    if (keyType === 'segment') {
      // Use the first part of the path (e.g., '/users' for '/users/123')
      const firstSegment = `/${location.pathname.split('/')[1]}/${location.pathname.split('/')[2]}`;
      return firstSegment || location.pathname;
    }
    // Default to the full path
    return location.pathname;
  };

  const key = getKey();

  return (
    <AnimatePresence mode="wait">
      <motion.div
        key={key}
        exit={{ opacity: 0, transition: { duration: 0.01 } }}
        initial={{
          opacity: 0,
          x: slide,
          y: slideUp,
          transition: { duration: 0.25 },
        }}
        animate={{ opacity: 1, x: 0, y: 0, transition: { duration: 0.25 } }}
      >
        {outlet}
      </motion.div>
    </AnimatePresence>
  );
};

OutletWrapper.defaultProps = {
  slide: 0,
  slideUp: 0,
  keyType: 'full',
};

OutletWrapper.propTypes = {
  slide: PropTypes.number,
  slideUp: PropTypes.number,
  keyType: PropTypes.string,
};

export default OutletWrapper;
